module.exports = __webpack_public_path__ + "static/fonts/CenturyGothic-Regular.040d1be.ttf";